<template>
  <dc-layout-main>
    <dc-layout-content>
<!--      <a-tabs v-model:activeKey="queryForm.appId" @change="success()">-->
<!--        <a-tab-pane key="cos_fbu"  v-if="permissionBtn.includes('visittosign_fbu_manage_btn')" tab="谷仓销售管理"></a-tab-pane>-->
<!--        <a-tab-pane key="cos_lbu"  v-if="permissionBtn.includes('visittosign_lbu_manage_btn')" tab="云途销售管理"></a-tab-pane>-->
<!--      </a-tabs>-->
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef"  tableId="DcCosVisitToSign">
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerNumber" label="客户代码">
              <a-input v-model:value="queryForm.customerNumber" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="createBy" label="创建人">
              <user-select v-model:value="queryForm.createBy" />
            </dc-form-item>
            <dc-form-item name="startTime" label="签到时间">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
            <dc-form-item name="cosId" label="客户ID">
              <a-input v-model:value="queryForm.cosId" placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'customerName'">
            <a @click="goDetail(record)">{{ record.customerName }}</a>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_visittosign_delete'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <!-- <a-button type="primary" @click="addEdit()"><span class="iconfont icon-xinzeng" />新增</a-button> -->
          <ExportButton v-show="queryForm.appId==='cos_fbu'" appId="cos_fbu" taskType="210" :search="queryForm"  v-permission="'fbu_visittosign_export'">导出</ExportButton>

        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { signInRecordList, signInRecordDelete } from '@/api/gucangSales/visitToSign'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import { useRouter } from 'vue-router'
import { usePermissionStore } from '@/stores/permission'
export default { name: 'DcCosFbuVisitToSign' }

</script>
<script setup lang="ts">
const editModalRef = ref<{ toggle:(row?: BigScoreBakcData) => void }>()
const router = useRouter()

const tableRef = ref()
const permissionStore = usePermissionStore()
const permissionBtn = permissionStore.permission
const showAppid = () => {
  if (permissionBtn.includes('visittosign_fbu_manage_btn')) {
    return 'cos_fbu'
  }
  if (permissionBtn.includes('visittosign_lbu_manage_btn')) {
    return 'cos_lbu'
  }
  if (!permissionBtn.includes('visittosign_fbu_manage_btn') && !permissionBtn.includes('visittosign_lbu_manage_btn')) {
    return ''
  }
}
const queryForm = reactive({
  appId: 'cos_fbu',
  customerNumber: '',
  customerName: '',
  createBy: undefined,
  startTime: '',
  endTime: ''
})
const goDetail = (row: {id:number}) => {
  router.push({
    path: '/fbu/visitToSignDetail',
    query: {
      id: row.id
    }
  })
}

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  console.log('params: ', params)
  const res = await signInRecordList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.search()
}
const columns = computed(() => [
  { title: '客户代码', dataIndex: 'customerNumber' },
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '客户ID', dataIndex: 'cosId' },
  { title: '客户详细地址', dataIndex: 'customerAddress' },
  { title: '签到时间', dataIndex: 'signInTime' },
  { title: '关联访客计划', dataIndex: 'visitPlanTitle' },
  { title: '备注', dataIndex: 'comment' },
  { title: '创建人', dataIndex: 'createByName' },

  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
// const addEdit = (_row?: BigScoreBakcData) => {
//   editModalRef.value?.toggle(_row)
// }
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      signInRecordDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>

<style scoped></style>
